import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { fetch_all_active_agents, transfer_member } from '../../../../services/met/Service';
import { LoaderLoader } from '../../../utils/CommonLibrary';



const TransferMemberModal = ({transferMemberPopupOpen, setTransfermemberPopupOpen, singleUserData, userDataList, reflect, setReflect, closeCallPopup}) => {
    
    const [agentsList, setAgentsList]  = useState([]); 
    const [isLoading, setIsLoading] = useState(false); 
    const [isRequestLoading, setIsRequestLoading] = useState(false); 
    
    useEffect(() => { 
        fetchAllAgents(); 
    }, []); 

    const [pendingUsersCount, setPendingUsersCount] = useState(0);
    const [selectedAgent, setSelectedAgent] = useState('');

    useEffect(() => {
        const countPendingUsers = () => {
            const pendingCount = userDataList.filter(user => user.actionTaken === false).length;
            setPendingUsersCount(pendingCount);
        };

        countPendingUsers();
    }, [userDataList]);

    async function fetchAllAgents (){ 
        setIsLoading(true);
        try{ 
            let resopnse= await fetch_all_active_agents(); 
            
            if(resopnse.data.code === 200){ 
                setAgentsList(resopnse.data?.data?.data || []); 
            }
        }catch(e){ 

        }finally{ 
            setIsLoading(false)
        }
    }

    const handleAgentChange = (event) => {
        setSelectedAgent(event.target.value);
    };

    const handleSubmit =  async (event) => {
        event.preventDefault();
        setIsRequestLoading(true); 
        try {
            const response = await transfer_member({agentToTransfer: selectedAgent, memberToTransfer: singleUserData.encUserId});
            if (response.data.code === 200) {
                setReflect(!reflect); 
                closeCallPopup(); 
                setTransfermemberPopupOpen(false);
            }
        } catch (e) {
            console.error(e);
        }finally{ 
            setIsRequestLoading(false);
        }
    };

  return (
    <div className="tw-fixed tw-inset-0 tw-bg-black/45 tw-z-[9999]">
    <LoaderLoader isLoading={isLoading} />
    <Modal style={{zIndex:"9999"}} id="callHistoryDetails" show={transferMemberPopupOpen} onHide={() =>setTransfermemberPopupOpen(false)} centered size="md" backdrop="static" keyboard={false} fullscreen={false}>
    <Modal.Header closeButton>
      <Modal.Title>Transfer Member</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="memberName" className="form-label">Member Name:</label>
          <br />    
          <span className='tw-text-sm'> {singleUserData['memberName']}  {(pendingUsersCount - 1) > 0 && <span className='tw-text-sm'> & {pendingUsersCount - 1} other </span>}</span>
        </div>
        <div className="mb-3">
          <label htmlFor="agentSelect" className="form-label">Transfer to Agent:</label>
          <select className="form-select" id="agentSelect" value={selectedAgent} onChange={handleAgentChange} required>
            <option value="">Select an Agent</option>
            {
                agentsList.map((agent, index) => (
                    <option key={index} value={agent.id}>{agent.firstName + ' '  + agent.lastName}</option>
                ))
            }            
          </select>
        </div>
        <div className='tw-flex tw-justify-center tw-items-center'>
          <button type="submit" className="btn btn-success coach-call-enroll-btn " 
          disabled={isRequestLoading}            
         >
            {
                isRequestLoading ? "Transferring Member...": "Transfer Member"
            }
        </button>
        </div>
        
      </form>
    </Modal.Body>
  </Modal>          
  </div>
  )
}

export default TransferMemberModal